export default "__VITE_ASSET__CVU$nRDu__"